module.exports = __webpack_public_path__ + "static/img/menu1.e0f291a2.png";